import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { AiContentApiClient } from '../../api-clients';
const {
  Provider,
  ...client
} = AiContentApiClient;
export const AiContentExtension = createModuleExtension({
  extensionName: 'aiContentExtension',
  Provider,
  SDK: {
    aiContentApiClient: client
  }
});
//# sourceMappingURL=ai-content.extension.js.map